export const expectedOrderOfCnsProceduresTemplate = [
  'PCR: A Fragment',
  'PCR: B Fragment',
  'PCR: C Fragment',
  'PCR: D Fragment',
  'PCR: E Fragment',
  'PCR: F Fragment',
  'PCR: G Fragment',
  'PCR: H Fragment',
  'analyse: A fragment',
  'analyse: B fragment',
  'analyse: C fragment',
  'analyse: D fragment',
  'analyse: E fragment',
  'analyse: F fragment',
  'analyse: G fragment',
  'analyse: H fragment',
  'ligate: A+B',
  'analyse: end-seq AB',
  'ligate: AB+C',
  'analyse: end-seq ABC',
  'ligate: ABC+D',
  'analyse: end-seq ABCD',
  'ligate: ABCD+E',
  'analyse: end-seq ABCDE',
  'ligate: ABCDE+F',
  'analyse: end-seq ABCDEF',
  'ligate: ABCDEF+G',
  'analyse: end-seq ABCDEFG',
  'ligate: ABCDEFG+H',
  'analyse: end-seq ABCDEFGH',
  'QC-digest: targeting vector',
  'maxi-prep: targeting vector',
  'full-seq: targeting vector',
];
